module.exports = __webpack_public_path__ + "static/media/conversion_4_blue.0a9fdfba.png";